import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../Landing/LandingPage.module.css';
import api from '../../services/api'; 
import showToast from '../../components/ShowToast';
import Loader from '../../components/Loader';
import { FaPaperPlane, FaUser, FaEnvelope, FaPhone, FaCommentAlt, FaCheckCircle, FaArrowLeft } from 'react-icons/fa';
import imageLogo from "../../assets/images/BSPLogoTranSmall.png";

import contactImage from "../../assets/images/resi02.jpeg";
import { jwtDecode } from 'jwt-decode';
import { toast, ToastContainer } from 'react-toastify';

export const BusinessEnquiryPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    
    // Parse Query Params
    const params = new URLSearchParams(location.search);
    const crmId = params.get('crmId');           // e.g. ?crmId=50
    const businessId = params.get('businessId'); // e.g. ?businessId=102

    const [businessInfo, setBusinessInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    // 1. Fetch Business Name (Smart Endpoint)
    useEffect(() => {
        if (!crmId && !businessId) {
            navigate('/'); 
            return;
        }

        const fetchInfo = async () => {
            try {
                // We use the new display-info endpoint that handles both IDs
                const query = crmId ? `crmId=${crmId}` : `businessId=${businessId}`;
                const response = await api.get(`/api/Leads/display-info?${query}`);
                setBusinessInfo(response.data); // Expecting { name: "ABC Plumbing", type: "claimed" }
            } catch (error) {
                showToast('error', 'Could not load business details.');
            }
        };

        fetchInfo();
    }, [crmId, businessId, navigate]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.name || !formData.email || !formData.message) {
            showToast('error', 'Please fill in all required fields.');
            return;
        }

        setLoading(true);

        try {
            // 2. Logic to choose the correct Endpoint and Payload
            if (crmId) {
                // Scenario 1: Unclaimed / Shadow Profile
                const payload = {
                    CrmId: parseInt(crmId),
                    senderName: formData.name,
                    senderEmail: formData.email,
                    senderPhone: formData.phone,
                    message: formData.message
                };
                await api.post('/api/Leads/send-unclaimed', payload);
            } 
            else if (businessId) {


            const token = localStorage.getItem('token');
            if (!token) {
                toast.error("You must be logged in to save a business.");
                return;
            }
            const decodedToken = jwtDecode(token);
            const userType = decodedToken.UserType;

            const loggedInHomeUserId  = parseInt(localStorage.getItem('loggedInHomeUserId'), 10)  || 0;
            const loggedInBusinessId  = parseInt(localStorage.getItem('loggedInBusinessId'), 10)  || 0;

            var mySenderUserId = 0;
            var mySenderUserType = "";

            if (userType == "Home") {

                mySenderUserId = loggedInHomeUserId;
                mySenderUserType = "HomeUser";

            } else {
                mySenderUserId = loggedInBusinessId;
                mySenderUserType = "BusinessUser";
            }

                // Scenario 2: Sent from internal business profile popup
                const payload = {
                    BusinessId: parseInt(businessId),
                    senderName: formData.name,
                    senderEmail: formData.email,
                    senderPhone: formData.phone,
                    senderUserId: mySenderUserId,
                    senderUserType: mySenderUserType,
                    message: formData.message
                };
                await api.post('/api/Leads/send-enquiry', payload);
            }

            setSuccess(true);
        } catch (error) {
            console.error(error);
            showToast('error', 'Failed to send message. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className={styles.authContainer}>
                <div className={styles.authVisual}>
                    <img src={contactImage} alt="Modern Interior" />
                </div>
                <div className={styles.authFormContainer}>
                    <div className={styles.authForm} style={{textAlign: 'center'}}>
                        <div className={styles.confirmationContainer}>
                            <FaCheckCircle className={styles.confirmationIcon} style={{color: '#27ae60'}} />
                            <h1 className={styles.authTitle}>Enquiry Sent!</h1>
                            <p className={styles.authSubtitle}>
                                We have sent your message to <strong>{businessInfo?.name}</strong>. 
                                They typically respond within 24 hours.
                            </p>
                            <button onClick={() => navigate('/')} className={`${styles.btnPrimaryAuth} ${styles.linkButton}`}>
                                Back to Directory
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.authContainer}>
            {loading && <Loader />}
            
            <div className={styles.authVisual}>
                <div style={{
                    position: 'absolute', bottom: '10%', left: '10%', right: '10%', 
                    color: 'white', zIndex: 2, textShadow: '0 2px 4px rgba(0,0,0,0.8)'
                }}>
                    <h2 style={{fontSize: '2.5rem', marginBottom: '10px'}}>Get the Job Done.</h2>
                    <p style={{fontSize: '1.1rem', opacity: 0.9}}>Connect with top-rated local professionals in minutes.</p>
                </div>
                <img src={contactImage} alt="Contact Professional" />
            </div>

            <div className={styles.authFormContainer}>
                <div className={styles.authForm}>
                    <div style={{marginBottom: '30px', display: 'flex', alignItems: 'center', justifyContent:'space-between'}}>
                         <a href="/" className={styles.authLogo} style={{margin:0, display:'flex', alignItems:'center'}}>
                            <img src={imageLogo} alt="Logo" style={{ height: '30px', marginRight: '10px' }} />
                            
                        </a>
                        <button onClick={() => window.history.back()} style={{background:'none', border:'none', color:'#666', cursor:'pointer', display:'flex', alignItems:'center', gap:'5px'}}>
                            <FaArrowLeft /> Back
                        </button>
                    </div>

                    {businessInfo ? (
                        <>
                            <h1 className={styles.authTitle}>Contact {businessInfo.name}</h1>
                            <p className={styles.authSubtitle}>
                                Fill out the form below to request a quote or ask a question.
                            </p>
                        </>
                    ) : (
                        <h1 className={styles.authTitle}>Loading...</h1>
                    )}

                    <form onSubmit={handleSubmit}>
                        {/* INPUT FIELDS REMAIN EXACTLY THE SAME AS YOUR CODE */}
                        <div className={styles.formGroup}>
                            <label htmlFor="name">Your Name</label>
                            <div className={styles.formBox} style={{position:'relative'}}>
                                <input type="text" name="name" value={formData.name} onChange={handleChange} required className={styles.formInput} placeholder="John Doe" style={{paddingLeft: '40px'}} />
                                <FaUser style={{position: 'absolute', left: '12px', top: '14px', color: '#aaa'}} />
                            </div>
                        </div>

                        <div className={styles.formRow}>
                            <div className={styles.formGroup}>
                                <label htmlFor="email">Email</label>
                                <div className={styles.formBox} style={{position:'relative'}}>
                                    <input type="email" name="email" value={formData.email} onChange={handleChange} required className={styles.formInput} placeholder="john@email.com" style={{paddingLeft: '40px'}} />
                                    <FaEnvelope style={{position: 'absolute', left: '12px', top: '14px', color: '#aaa'}} />
                                </div>
                            </div>
                            <div className={styles.formGroup}>
                                <label htmlFor="phone">Phone (Optional)</label>
                                <div className={styles.formBox} style={{position:'relative'}}>
                                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className={styles.formInput} placeholder="0400..." style={{paddingLeft: '40px'}} />
                                    <FaPhone style={{position: 'absolute', left: '12px', top: '14px', color: '#aaa'}} />
                                </div>
                            </div>
                        </div>

                        <div className={styles.formGroup}>
                            <label htmlFor="message">How can they help?</label>
                            <div className={styles.formBox} style={{position:'relative'}}>
                                <textarea name="message" value={formData.message} onChange={handleChange} required className={styles.formInput} placeholder="Hi, I need a quote for..." rows="5" style={{paddingLeft: '40px', fontFamily: 'inherit'}} />
                                <FaCommentAlt style={{position: 'absolute', left: '12px', top: '14px', color: '#aaa'}} />
                            </div>
                        </div>

                        <div className={styles.terms} style={{marginBottom: '20px'}}>
                            <p>By sending this message, you agree to our <a href="/terms" className={styles.link}>Terms</a>. Your details are sent directly to the business.</p>
                        </div>

                        <button type="submit" className={styles.btnPrimaryAuth} disabled={loading}>
                            {loading ? 'Sending...' : 'Send Message'} <FaPaperPlane style={{marginLeft:'8px'}}/>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};